import { render, staticRenderFns } from "./CompanyNoticeEdit.vue?vue&type=template&id=a7ba4f60&scoped=true&lang=pug&"
import script from "./scripts/CompanyNoticeEdit.js?vue&type=script&lang=js&"
export * from "./scripts/CompanyNoticeEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ba4f60",
  null
  
)

export default component.exports